import React, { useMemo, useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { useLocation, useHistory } from 'react-router-dom';
import QueryString from 'query-string';
import NextButton from 'components/Common/NextButton';
import backArrow from 'assets/images/ic-line-arrow-left.svg';
import eyeIcon from 'assets/images/ic-fill-eye.svg';
import eyeOffIcon from 'assets/images/ic-fill-eye-off.svg';
import { useAppContext } from 'components/AppContext';
import { validatePassword } from 'utils/password';
import AuthWrapper from './AuthWrapper';

export default function Login() {
  const location = useLocation();
  const history = useHistory();
  const { signup } = useAppContext();
  const { email } = useMemo(() => QueryString.parse(location.search), [location]);
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);

  const handleLogin = async () => {
    setError(null);

    if (!validatePassword(password)) {
      setError('Password must be at least 8 characters with mixture of uppercase, lowercase, numeric and inclusion of at least one special character');
      return;
    }

    const { success, error } = await signup(email, password);

    if (!success) {
      setError(error.data?.message || 'Something went wrong');
    }
  };

  return (
    <AuthWrapper>
      <div className="actions">
        <img
          alt="back"
          src={backArrow}
          className="u-cursorPointer"
          onClick={() => {
            history.replace('/get-started');
          }}
        />
      </div>
      <div className="header">
        <div className="title">Welcome to Auto Design</div>
        <div className="sub-title">Enter your password to complete signup</div>
      </div>

      <div className="body">
        <Form.Group className="form-group" hasValidation>
          <Form.Label>Password</Form.Label>
          <InputGroup className="password-input-group">
            <Form.Control
              placeholder="Enter your password"
              type={showPassword ? 'text' : 'password'}
              isInvalid={!!error}
              value={password}
              onChange={e => {
                setPassword(e.target.value);
                setError(null);
              }}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  handleLogin();
                }
              }}
            />
            <InputGroup.Text>
              <img
                alt="showPassword"
                className="u-cursorPointer"
                src={showPassword ? eyeOffIcon : eyeIcon}
                onClick={() => {
                  setShowPassword(!showPassword);
                }}
              />
            </InputGroup.Text>
          </InputGroup>
          {error && (
          <Form.Text className="u-textNegative">
            {error}
          </Form.Text>
          )}
        </Form.Group>

        <NextButton
          text="Create an account"
          className="submit-button"
          onClick={handleLogin}
          disabled={password.trim() === ''}
        />
      </div>
    </AuthWrapper>
  );
}
